import { useState } from "react";
import { Button } from "@/components/ui/button";
import { QuoteRequestModal } from "./quote-request-modal";
import { Calculator } from "lucide-react";

export function FloatingQuoteButton() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="fixed bottom-6 left-6 z-50">
        <Button
          onClick={() => setShowModal(true)}
          className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg hover:shadow-xl transition-all duration-300 glow-effect hover-lift px-6 py-3 rounded-full"
        >
          <Calculator className="w-5 h-5 mr-2" />
          <span className="font-semibold">Solicita tu presupuesto</span>
        </Button>
      </div>
      
      <QuoteRequestModal 
        open={showModal} 
        onOpenChange={setShowModal} 
      />
    </>
  );
}